<div class="col-md-12">
    <h3 class="">Set Compliance/Due Dates</h3>  
    <hr style="margin: 0;border: lightgray solid 0.5px; ">
    <br />
    <div class="clearfix"></div>
      <br /> <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Compliance Name</th>
            <th scope="col" class="col-md-2">From Date({{curdate}})</th>
            <th scope="col" class="col-md-2">To Date({{curdate}})</th>
            <th colspan="2" scope="col" >Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let _trans of mstCompliances">
            <td>{{ _trans.ComplianceName }}</td>
            <td class="col-md-2"> <input [(ngModel)]="_trans.FromDate" numeric numericType="number" placeholder="From Date"   name="FromDate" [value]="_trans.FromDate" 
              class="form-control" id="FromDate"></td>
            <td class="col-md-2"> <input [(ngModel)]="_trans.ToDate" numeric numericType="number" placeholder="To Date"   name="ToDate" [value]="_trans.ToDate" numeric
              class="form-control" id="ToDate">
              </td>
            <td> 
              <a (click) = "updateConfirm(_trans)" class="btn btn-primary">Update</a>
            </td>
            
          </tr>
        </tbody>
      </table>
    </div>